import { ApolloLink } from '@apollo/client';
import createHttpHeadersLink from './links/createHttpHeadersLink';
import createTerminatingLink from './links/createTerminatingLink';
import createExtensionsLink from './links/createExtensionsLink';
export default function createV2ApolloLink(routeThroughEdge) {
    return ApolloLink.from([
        createExtensionsLink(),
        createHttpHeadersLink(routeThroughEdge),
        createTerminatingLink(routeThroughEdge)
    ]);
}

//# sourceMappingURL=createV2ApolloLink.js.map